const API = import.meta.env.VITE_API_BASE_URL;
const url = `${API}/messages`;



export const fetchGetTarifNotification = async (session_id: string) => {
	try {
		const formData = new FormData();
		formData.append('session_id', session_id);

		const response = await fetch(url, {
			method: 'POST',
			body: formData,
		});

		const contentType = response.headers.get('content-type');

		if (contentType && contentType.includes('application/json')) {
			const data = await response.json();

			return data;
		} else {
			const textData = await response.text();
			console.error('Not JSON response:', textData);
			throw new Error('Server returned non-JSON response');
		}
	} catch (error) {
		console.error('Fetch error:', error);
	}
};

export const fetchAddTarifNotification = async ({ session_id, message }: { session_id: string; message: string }) => {
	try {
		const formData = new FormData();
		formData.append('session_id', session_id);
		formData.append('message', message);

		const response = await fetch(url, {
			method: 'POST',
			body: formData,
		});

		if (!response.ok) {
			const errorText = await response.text();
			console.error(`HTTP Error: ${response.status} - ${response.statusText}`, errorText);
			throw new Error(`HTTP Error: ${response.status}`);
		}

		const contentType = response.headers.get('content-type');

		if (contentType && contentType.includes('application/json')) {
			const data = await response.json();

			return data;
		} else {
			const textData = await response.text();
			console.error('Not JSON response:', textData);
			throw new Error('Server returned non-JSON response');
		}
	} catch (error) {
		console.error('Fetch error:', error);
	}
};

export const fetchDeleteTarifNotification = async (session_id: string) => {
	try {
		const formData = new FormData();
		formData.append('session_id', session_id);

		const response = await fetch(url, {
			method: 'DELETE',
			body: formData,
		});

		if (!response.ok) {
			const errorText = await response.text();
			console.error(`HTTP Error: ${response.status} - ${response.statusText}`, errorText);
			throw new Error(`HTTP Error: ${response.status}`);
		}

		const contentType = response.headers.get('content-type');

		if (contentType && contentType.includes('application/json')) {
			const data = await response.json();

			return data;
		} else {
			const textData = await response.text();
			console.error('Not JSON response:', textData);
			throw new Error('Server returned non-JSON response');
		}
	} catch (error) {
		console.error('Fetch error:', error);
	}
};
